








































import { Component, Prop, mixins } from 'nuxt-property-decorator'
import LightBox from 'vue-it-bigger'
import globalStyling from '~/mixins/globalStyling'
import DefaultImage from '~/mixins/defaultImage'

@Component({
  mixins: [globalStyling],
  components: { LightBox },
})
export default class MobileCardAmenity extends mixins(
  globalStyling,
  DefaultImage
) {
  @Prop({ default: null }) name: string
  @Prop({ default: null }) description: string
  @Prop({ default: null }) photos: Array<string>

  lightboxVisible: boolean = false

  get formattedPhotos(): Array<{ src: string; thumb: string }> {
    return this.photos.map((photo) => ({ src: photo, thumb: photo }))
  }

  openLightbox(): void {
    this.lightboxVisible = true
  }

  handleLightboxClose(): void {
    this.lightboxVisible = false
  }
}
